import * as v from "valibot";

import { rpcContract } from "../rpc";

export const analyticsRpcContract = rpcContract({
  name: "analytics",
  paramsSchema: v.object({
    startDate: v.date(),
    endDate: v.date(),
    filter: v.string(),
  }),
  resultSchema: v.object({
    chartData: v.optional(
      v.object({
        labels: v.array(v.string()),
        datasets: v.array(
          v.object({
            label: v.string(),
            data: v.array(v.number()),
          }),
        ),
      }),
    ),
    subscribers: v.optional(
      v.object({
        total: v.number(),
        progress: v.number(),
        emails: v.array(v.object({ id: v.string(), email: v.string() })),
      }),
    ),
    views: v.object({
      total: v.number(),
      progress: v.number(),
    }),
    uniqueProfileVisitors: v.optional(
      v.object({
        total: v.number(),
        progress: v.number(),
      }),
    ),
    clicks: v.object({
      total: v.number(),
      progress: v.number(),
    }),
    ctr: v.object({
      total: v.number(),
      progress: v.number(),
    }),
    copyCodeClicks: v.optional(
      v.object({
        total: v.number(),
        progress: v.number(),
      }),
    ),
    shopClicks: v.optional(
      v.object({
        total: v.number(),
        progress: v.number(),
      }),
    ),
    ticketsSold: v.optional(
      v.object({
        total: v.number(),
        progress: v.number(),
      }),
    ),
    totalEarnings: v.optional(
      v.object({
        total: v.number(),
        progress: v.number(),
        currency: v.nullable(v.string()),
      }),
    ),
    metaItems: v.optional(
      v.array(
        v.object({
          id: v.string(),
          thumbnail: v.optional(v.string()),
          title: v.optional(v.string()),
          mediaUrl: v.optional(v.string()),
          imageUrl: v.optional(v.string()),
          statistics: v.optional(
            v.object({
              clicks: v.optional(v.number()),
              views: v.optional(v.number()),
              ctr: v.optional(v.number()),
              copyCodeClicks: v.optional(v.number()),
              shopClicks: v.optional(v.number()),
              clicksProgress: v.optional(v.number()),
              viewsProgress: v.optional(v.number()),
              ctrProgress: v.optional(v.number()),
              copyCodeClicksProgress: v.optional(v.number()),
              shopClicksProgress: v.optional(v.number()),
            }),
          ),
        }),
      ),
    ),
  }),
});

export type AnalyticsParams = v.InferOutput<(typeof analyticsRpcContract)["paramsSchema"]>;

export type AnalyticsResult = v.InferOutput<(typeof analyticsRpcContract)["resultSchema"]>;
